import React from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { ChangeEvent } from 'react';

interface FormikCheckBoxProps {
  type: string;
  name: string;
  label: string;
  fieldValue: {
    value: boolean;
  };
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const FormikCheckBox: React.FC<FormikCheckBoxProps> = ({
  fieldValue,
  handleChange,
  label,
  name
}) => {
  return (
    <Box sx={{ mt: 1, mb: 1, display: 'flex', alignItems: 'center' }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={fieldValue.value || false}
            name={name}
            onChange={handleChange}
            color="primary"
          />
        }
        label={label}
        sx={{
          alignItems: 'center'
        }}
      />
    </Box>
  );
};

export default FormikCheckBox;
